/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterMaterial_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterMaterial_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_viewer$ref,
  +$refType: SbSharedRefineMenuFilterMaterial_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMaterial_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f1ee0f61f00d2c93120f509f2ef54cde';
module.exports = node;
